<template>
  <div class="popin popin-infos">
    <div :class="'popin-container'">
      <div class="popin-close" @click="closePopin"></div>

      <template v-if="params.typeInfos === 'character'">
         <img :src="params.img" :alt="params.name">

        <div>
          <p class="popin-infos__name">{{ params.name }}</p>

          <p class="popin-infos__description" v-html="params.descr"></p>
        </div>

        <a class="popin-infos__btn btn" @click="closePopin">
          Fermer
        </a>
      </template>

      <template v-if="params.typeInfos === 'person'">
        <img :src="`http://transfertsdepekin.fr/assets/questions/${params.characterImg}`" :alt="params.character">

        <div>
          <p class="popin-infos__name">{{ params.character }}</p>

          <p class="popin-infos__description" v-html="params.bio"></p>
        </div>

        <a class="popin-infos__btn btn" @click="closePopin">
          Fermer
        </a>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'popin-infos',
    props: [
			'params',
    ],
    methods: {
      closePopin() {
        this.$store.commit('setShowPopin', false);
      },
    },
  };
</script>


<style lang="scss">
  .popin-infos.popin {
    img {
      display: block;
      margin: auto;
    }

    @include mobile {
      overflow-y: scroll;
      padding-bottom: 30px;
    }

    .popin-container {
      width: 711px;
      height: 557px;
      background: url('../assets/img/bg_bio.png') no-repeat center center;
      background-size: contain;

      @include mobile {
        width: 100%;
        height: auto;
        padding: 50px 0;
        background: none;
      }
    }

    .popin-infos__name {
      text-align: center;
      color: $blue;
      font-weight: 600;
      margin-top: 15px;
      margin-bottom: 30px;
      @include fontSize(35);
    }

    .popin-infos__description {
      color: $blue;
      text-align: center;
      padding: 0 10%;
      line-height: 1.8;
      @include fontSize(16);

      a {
        color: $orange;
        @include defaultTransition(.4);

        &:hover {
          color: $blue;
        }
      }
    }

    img {
      display: block;
      margin: -20px auto 0;
      max-width: 150px;

      @include mobile {
        margin-top: 0;
      }
    }
  }

  .popin-infos__btn {
    position: relative;
    display: block;
    margin: auto;
    top: 30px;
    width: 200px;
    color: $white;
    background: $orange;
    border-color: $orange;
    text-align: center;
    padding: 8px 15px;
    cursor: pointer;
    text-transform: uppercase;
    @include fontSize(23);

    &:hover {
      color: $orange;
      background: $white;
    }
  }

  .popin-close {
    position: absolute;
    top: 30px;
    right: 30px;
    width: 30px;
    height: 30px;
    background: $white;
    border-radius: 100%;
    transform: rotate(45deg);
    cursor: pointer;
    @include defaultTransition(.4);

    &::before,
    &::after {
      position: absolute;
      background: $blue;
      content: '';
      @include defaultTransition(.4);
    }

    &::before {
      top: 15%;
      left: 50%;
      width: 1px;
      height: 70%;
      transform: translateX(-50%);
    }

    &::after {
      top: 50%;
      left: 15%;
      width: 70%;
      height: 1px;
      transform: translateY(-50%);
    }

    &:hover {
      background: $blue;

      &::before,
      &::after {
        background: $white;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// PopinInfos.vue?743318b0